import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "../../../types/RouteType";

const yardMapRoute: RouteType = {
  name: "Yard Map",
  path: "/yard/map",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./YardMap.Header"),
      title: "Yard Layout Map",
      enableBackButton: true,
      enableRefreshButton: true,
    },
    body: {
      component: () => import("./YardMap.Body"),
      grayBackground: true,
    },
  },
  group: "Yard",
  requiresAuth: true,
  requiresPermission: false,
  hidden: true,
  dialogs: [
    {
      name: "Add Location",
      component: () => import("../YardDialogs/AddLocation.Dialog"),
      title: "Add Yard Location",
      onSubmit: async ({ rootStore }) => {
        // Dialog submission logic will be handled by the dialog component
        return true;
      },
      onSubmitValidation: ({ rootStore }) => {
        // Dialog validation will be handled by the dialog component
        return true;
      },
      cancelButton: true,
      height: 600,
    },
    // Temporarily disabled until dialog implementation is updated
    // {
    //     name: "Edit Location",
    //     component: () => import("../YardDialogs/EditLocation.Dialog"),
    //     title: "Edit Yard Location",
    //     onSubmit: async ({ rootStore }) => {
    //         return true;
    //     },
    //     onSubmitValidation: ({ rootStore }) => {
    //         return true;
    //     },
    //     cancelButton: true,
    //     height: 600,
    // },
    // {
    //     name: "Move Inventory",
    //     component: () => import("../YardDialogs/MoveInventory.Dialog"),
    //     title: "Move Inventory Item",
    //     onSubmit: async ({ rootStore }) => {
    //         return true;
    //     },
    //     onSubmitValidation: ({ rootStore }) => {
    //         return true;
    //     },
    //     cancelButton: true,
    //     height: 500,
    // },
  ],
  beforeEnter: async ({ rootStore }) => {
    try {
      const yardLocationsStore = rootStore.yardLocationsStore as ServiceStore;
      const yardInventoryItemsStore =
        rootStore.yardInventoryItemsStore as ServiceStore;
      const yardMapsStore = rootStore.yardMapsStore as ServiceStore;
      const yardMapLocationAssignmentsStore =
        rootStore.yardMapLocationAssignmentsStore as ServiceStore;

      await Promise.all([
        yardLocationsStore.find({ query: { $limit: 100 } }),
        yardInventoryItemsStore.find({ query: { $limit: 100 } }),
        yardMapsStore.find({ query: { $limit: 100 } }),
        yardMapLocationAssignmentsStore.find({ query: { $limit: 100 } }),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load yard map data:", error);
      return false;
    }
  },
};

export default yardMapRoute;
